import React, { ReactElement, ReactNode } from 'react'
import { IconButton } from './Button'
import Dropdown from './Dropdown'
import NewDots from '../icons/NewDots'
import Close from '../icons/Close'
import CopyButton from './CopyButton'
import AnimatedTabs from './AnimatedTabs'
import {
  Overlay,
  DrawerPanel,
  DrawerInner,
  DrawerHeader,
  DrawerTitleGroup,
  DrawerEyebrow,
  DrawerTitle,
  DrawerActions,
  DrawerMenuContent,
  DrawerTabsWrapper,
  FieldWrapper,
  FieldLabel,
  FieldBox,
  FieldBoxValue,
  FieldInline
} from './AccountDetailsDrawerStyles'

interface AccountDetailsDrawerProps {
  visible: boolean
  onClose: () => void
  eyebrow: string
  title?: string
  menu?: ReactNode
  tabs?: string[]
  selectedTab?: string
  onTabChange?: (tab: string) => void
  children?: ReactNode
}

const AccountDetailsDrawer = ({
  visible,
  onClose,
  eyebrow,
  title,
  menu,
  tabs,
  selectedTab,
  onTabChange,
  children
}: AccountDetailsDrawerProps): ReactElement => {
  return <>
    {visible && <Overlay onClick={onClose} />}

    <DrawerPanel $visible={visible}>
      <DrawerInner>
        <DrawerHeader>
          <DrawerTitleGroup>
            <DrawerEyebrow>{eyebrow}</DrawerEyebrow>
            <DrawerTitle>{title}</DrawerTitle>
          </DrawerTitleGroup>
          <DrawerActions>
            {menu && (
              <Dropdown
                noChevron
                selectedContent={<NewDots width={20} />}
                dropdownContent={<DrawerMenuContent>{menu}</DrawerMenuContent>}
              />
            )}
            <IconButton type='button' onClick={onClose} style={{ padding: 6 }}>
              <Close width={16} height={16} />
            </IconButton>
          </DrawerActions>
        </DrawerHeader>

        {tabs && tabs.length > 0 && selectedTab && onTabChange && (
          <DrawerTabsWrapper>
            <AnimatedTabs
              selectedTab={selectedTab}
              tabs={tabs}
              onTabChange={onTabChange}
            />
          </DrawerTabsWrapper>
        )}

        {children}
      </DrawerInner>
    </DrawerPanel>
  </>
}

interface DrawerFieldProps {
  label: string
  value?: ReactNode
  copy?: string
  mono?: boolean
  boxed?: boolean
  trailing?: ReactNode
  children?: ReactNode
}

export const DrawerField = ({
  label,
  value,
  copy,
  mono,
  boxed = true,
  trailing,
  children
}: DrawerFieldProps): ReactElement => {
  const content = children ?? value
  return (
    <FieldWrapper>
      <FieldLabel>{label}</FieldLabel>
      {boxed
        ? <FieldBox>
          <FieldBoxValue $mono={mono}>{content}</FieldBoxValue>
          {trailing}
          {copy && <CopyButton text={copy} />}
        </FieldBox>
        : <FieldInline>{content}</FieldInline>
      }
    </FieldWrapper>
  )
}

export default AccountDetailsDrawer
